import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    move: {
        progress: (itemCount: number) => string;
        completed: (itemCount: number) => string;
        failed: (itemCount: number) => string;
    };
    delete: {
        progress: (itemCount: number) => string;
        completed: (itemCount: number) => string;
        failed: (itemCount: number) => string;
    };
    copy: {
        progress: (itemCount: number) => string;
        completed: (itemCount: number) => string;
        failed: (itemCount: number) => string;
    };
    updateFieldValues: {
        progress: (itemCount: number) => string;
        completed: (itemCount: number) => string;
        failed: (itemCount: number) => string;
    };
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            move: {
                get() {
                    return Object.defineProperties({
                        [__intl__.BOUND_INTL]: this[__intl__.BOUND_INTL] ?? __intl__.getIntl()
                    }, {
                        progress: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (itemCount: number): string => __intl__.intl().formatMessage({ id: "BulkAssetOperationsContext.move.progress?c=3njwdbr4ra657", defaultMessage: "{itemCount, plural, one {Moving {itemCount} item...} other {Moving {itemCount} items...}}" }, { itemCount: itemCount }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        completed: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (itemCount: number): string => __intl__.intl().formatMessage({ id: "BulkAssetOperationsContext.move.completed?c=338y6ut4mveln", defaultMessage: "{itemCount, plural, one {Moved {itemCount} item} other {Moved {itemCount} items}}" }, { itemCount: itemCount }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        failed: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (itemCount: number): string => __intl__.intl().formatMessage({ id: "BulkAssetOperationsContext.move.failed?c=3tcskzr8cwrst", defaultMessage: "{itemCount, plural, one {Failed to move {itemCount} item} other {Failed to move {itemCount} items}}" }, { itemCount: itemCount }));
                            },
                            enumerable: true,
                            configurable: true
                        }
                    });
                },
                enumerable: true,
                configurable: true
            },
            delete: {
                get() {
                    return Object.defineProperties({
                        [__intl__.BOUND_INTL]: this[__intl__.BOUND_INTL] ?? __intl__.getIntl()
                    }, {
                        progress: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (itemCount: number): string => __intl__.intl().formatMessage({ id: "BulkAssetOperationsContext.delete.progress?c=2moc8nt81bt9u", defaultMessage: "{itemCount, plural, one {Deleting {itemCount} item...} other {Deleting {itemCount} items...}}" }, { itemCount: itemCount }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        completed: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (itemCount: number): string => __intl__.intl().formatMessage({ id: "BulkAssetOperationsContext.delete.completed?c=1oeh7w0yus6cc", defaultMessage: "{itemCount, plural, one {Deleted {itemCount} item} other {Deleted {itemCount} items}}" }, { itemCount: itemCount }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        failed: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (itemCount: number): string => __intl__.intl().formatMessage({ id: "BulkAssetOperationsContext.delete.failed?c=31tmbmbtla4tr", defaultMessage: "{itemCount, plural, one {Failed to delete {itemCount} item} other {Failed to delete {itemCount} items}}" }, { itemCount: itemCount }));
                            },
                            enumerable: true,
                            configurable: true
                        }
                    });
                },
                enumerable: true,
                configurable: true
            },
            copy: {
                get() {
                    return Object.defineProperties({
                        [__intl__.BOUND_INTL]: this[__intl__.BOUND_INTL] ?? __intl__.getIntl()
                    }, {
                        progress: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (itemCount: number): string => __intl__.intl().formatMessage({ id: "BulkAssetOperationsContext.copy.progress?c=2oui26x75x2vw", defaultMessage: "{itemCount, plural, one {Copying {itemCount} item...} other {Copying {itemCount} items...}}" }, { itemCount: itemCount }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        completed: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (itemCount: number): string => __intl__.intl().formatMessage({ id: "BulkAssetOperationsContext.copy.completed?c=sa3b5ap6c1ta", defaultMessage: "{itemCount, plural, one {Copying {itemCount} item} other {Copying {itemCount} items}}" }, { itemCount: itemCount }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        failed: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (itemCount: number): string => __intl__.intl().formatMessage({ id: "BulkAssetOperationsContext.copy.failed?c=1m13d1u7994op", defaultMessage: "{itemCount, plural, one {Failed to copy {itemCount} item} other {Failed to copy {itemCount} items}}" }, { itemCount: itemCount }));
                            },
                            enumerable: true,
                            configurable: true
                        }
                    });
                },
                enumerable: true,
                configurable: true
            },
            updateFieldValues: {
                get() {
                    return Object.defineProperties({
                        [__intl__.BOUND_INTL]: this[__intl__.BOUND_INTL] ?? __intl__.getIntl()
                    }, {
                        progress: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (itemCount: number): string => __intl__.intl().formatMessage({ id: "BulkAssetOperationsContext.updateFieldValues.progress?c=9ljmqrkirfaa", defaultMessage: "{itemCount, plural, one {Updating {itemCount} item...} other {Updating {itemCount} items...}}" }, { itemCount: itemCount }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        completed: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (itemCount: number): string => __intl__.intl().formatMessage({ id: "BulkAssetOperationsContext.updateFieldValues.completed?c=2l4bzfwzi8t7e", defaultMessage: "{itemCount, plural, one {Updating {itemCount} item} other {Updating {itemCount} items}}" }, { itemCount: itemCount }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        failed: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (itemCount: number): string => __intl__.intl().formatMessage({ id: "BulkAssetOperationsContext.updateFieldValues.failed?c=13s3jxok1ymk6", defaultMessage: "{itemCount, plural, one {Failed to update {itemCount} item} other {Failed to update {itemCount} items}}" }, { itemCount: itemCount }));
                            },
                            enumerable: true,
                            configurable: true
                        }
                    });
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
